export const OPEN_COOKIE_PREFERENCES_EVENT = 'owlscran:cookie-preferences:open';
export const COOKIE_CONSENT_UPDATED_EVENT = 'owlscran:cookie-consent:updated';
